import React from 'react';
import useValuePerYearTotalChart from './hooks/useValuePerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ValuePerYearTotal = ({ heigth = 400 }) => {
    const { series, subtitles } = useValuePerYearTotalChart();

    return (
        <SimpleBars
            series={series}
            values={[]}
            subtitles={subtitles}
            isMoney
            title={`Soma do Valor por Ano`}
        />
    );
};
